export const getSemaforoColor = (horasTranscurridas, reglas) => {
  if (horasTranscurridas === null || horasTranscurridas === undefined) {
    return "semaforo__blanco";
  }

  if (!reglas) return "semaforo__blanco";

  const horas = horasTranscurridas;

  if (horas >= reglas.verde.min && horas < reglas.verde.max) {
    return "semaforo__verde";
  }

  if (horas >= reglas.amarillo.min && horas < reglas.amarillo.max) {
    return "semaforo__amarillo";
  }

  if (horas >= reglas.rojo.min) {
    return "semaforo__rojo";
  }

  return "semaforo__blanco";
};